var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelect',{staticClass:"w-100",attrs:{"inputId":"orderStatusPicker","inputLabel":"وضعیت سفارش","customOptions":_vm.filteredOrderStatusOptions,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }